import { DATASOURCE } from 'Constants'

let defaultDataObj = function() {
  return {"totalHits":0, "countries":{}, "totalCountries":0, "totalCities":0, "uniqueCountries":0, "uniqueCities":0};
}

const initialState = {
  regions: defaultDataObj(),
  loading: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case DATASOURCE.GEOREGIONS.KEY:
      return {
        ...state,
        regions:  parseData(action.data),
        loading: false
      };
    case DATASOURCE.GEOREGIONS.LOADING:
      return {
        ...state,
        regions: defaultDataObj(),
        loading: true
      };
    default:
      return state;
  }
};

let parseData = function(data) {
  let regions = defaultDataObj();
  regions.totalHits = data.hits;
  regions.totalCountries = data.totalCountries;
  regions.totalCities = data.totalCities;
  regions.uniqueCountries = data.uniqueCountries;
  regions.uniqueCities = data.uniqueCities;

  data.buckets.forEach((bucket) => {
    let gcc = bucket.key.geoCountryCode;
    let grc = bucket.key.geoRegionCode;
    
    if (gcc === "true") {
      return;
    }

    if (!regions.countries.hasOwnProperty(gcc)) {
      regions.countries[gcc] = {"total":0, "sinRegion":0, "regions":{}};
    }
    if (grc === "true") {
      regions.countries[gcc].sinRegion += bucket.doc_count;
    } else {
      if (!regions.countries[gcc].regions.hasOwnProperty(grc)) {
        regions.countries[gcc].regions[gcc+"-"+grc] = 0;
      }
      regions.countries[gcc].regions[gcc+"-"+grc] += bucket.doc_count;
    } 
    regions.countries[gcc].total += bucket.doc_count;
  });

  return regions;
};
